import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { IdentityProviderMessagingTokenResponse } from '@repo/shared/src/services/identity-provider/identity-provider.types';
import { BACK_API_URL } from '../../app.tokens';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  token: IdentityProviderMessagingTokenResponse | null = null;

  constructor(@Inject(BACK_API_URL) private readonly backApiUrl: string, private readonly http: HttpClient) {}

  postInitPayload(initPayload: string): Observable<IdentityProviderMessagingTokenResponse> {
    return this.http
      .post<IdentityProviderMessagingTokenResponse>(`${this.backApiUrl}/auth/token`, {
        initPayload: `${initPayload}`,
      })
      .pipe(
        tap(tokenResponse => {
          this.token = tokenResponse;
        }),
        catchError(err => {
          // TODO should we log in that way (with vanilla console.error)?
          console.error('AuthenticationService.postInitPayload():', err);

          return throwError(err);
        }),
      );
  }
}
